import React from 'react';
import './CTA.css';

const CTA = () => {
  return (
    <section className="cta-section" id="contact">
      <div className="container">
        <div className="cta-inner">

          {/* ── Left: Heading ── */}
          <h2 className="cta-heading">
            <span className="cta-heading-highlight">Ready to Modernize</span> your enterprise platforms with confidence?
          </h2>

          {/* ── Right: Button ── */}
          <a href="mailto:info@mstechnolofin.com" className="btn-cta">
            Get Started
          </a>

        </div>
      </div>
    </section>
  );
};

export default CTA;

